export default {
    en: { gdsText: require('./en/gds-text.json') },
};
